import InternalTableFilter from "@/ecm/models/contentType/ContentTypeFieldInternalTableFilter";
import InternalTable from '@/ecm/models/internalTable/InternalTable'
export default class ContentTypeFieldInternalTable {
    constructor (dto) {
        this.displayColumns = []
        this.filters = [new InternalTableFilter()]
        this.sortColumn = ''
        this.tableData = null;

        if (dto) {
            this.displayColumns = dto.DisplayColumns
            if(dto.Filters && dto.Filters.length > 0){
                this.filters = dto.Filters.map(x => new InternalTableFilter(x));
            }
            this.sortColumn = dto.SortColumn
            if (dto.TableData) {
                this.tableData = new InternalTable(dto.TableData);
            }
        }
    }

    toDto() {
        return {
            TableData: this.tableData ? Object.assign(new InternalTable(), this.tableData).toDto() : null
        };
    }
}
